/**
 * @generated SignedSource<<4bad117b81d4e26a133e7f88f85d314d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type profileMenuFragment$data = {
  readonly avatarUrl: string | null | undefined;
  readonly email: string;
  readonly name: string;
  readonly " $fragmentType": "profileMenuFragment";
};
export type profileMenuFragment$key = {
  readonly " $data"?: profileMenuFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"profileMenuFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "profileMenuFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2b87427dfa65c2ad3490979581d621c5";

export default node;
